import { FinanceType } from '@upstart/harmony/lib/constants';
import { getResidualValueFromPercent } from '@upstart/harmony/lib/payment-utils';
import { DeskingOfferCardProps } from './types';

export function getMrm({
  car,
  offer,
}: Pick<DeskingOfferCardProps, 'car' | 'offer'>) {
  return (offer?.data as any)?.mrm || car?.mrm || 0;
}

export function getDefaultResidualPercentage({
  car,
  offer,
}: Pick<DeskingOfferCardProps, 'car' | 'offer'>): number | undefined {
  if (offer.data?.financeType === FinanceType.LEASE) {
    const months = offer.data.months;
    const oemOffer = car?.oemOffers?.lease?.find(
      (o: any) => o.from <= months && o.to >= months,
    );
    const program = oemOffer?.programs?.find((p: any) => !!p.residuals);
    const residual =
      program?.residuals?.[`${offer.data.months}`]?.[`${offer.data.mileage}`];

    return residual;
  }
  return 0;
}

export function getResidualPercentage({
  car,
  dealer,
  offer,
}: Pick<DeskingOfferCardProps, 'car' | 'dealer' | 'offer'>) {
  if (offer.data?.financeType === FinanceType.LEASE) {
    const defaultResidualPercentage = getDefaultResidualPercentage({
      car,
      offer,
    });
    const mrm = getMrm({ car, offer });
    const residual = offer.data.residual ?? 0;
    const msrp = offer.data.msrp ?? 0;
    const calcedPercentage =
      car.msrp || car.price || offer.data?.msrp
        ? residual / getResidualValueFromPercent(dealer, car, mrm, 100, msrp)
        : (defaultResidualPercentage || 0) / 100 || 0;

    return calcedPercentage;
  }
  return 0;
}
